<template>
  <div class="addTeam">
    <div class="add_dialog">
      <div class="icon"><img src="../../../static/img/pc_logo.png"></div>
      <div class="title">hi,{{creator_name}}邀请你加入{{team_name}}项目</div>
      <div class="add_btn" @click="add_submit">确认加入</div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'addTeam',
  data: function () {
    return {
    }
  },
  computed: {
    creator_name () {
      return this.$route.query.creator_name
    },
    team_name () {
      return this.$route.query.team_name
    },
    team_no () {
      return this.$route.query.team_no
    }
  },
  methods: {
    add_submit () {
      let _this = this
      axios({
        method: 'get',
        url: _this.HOST + '/user/updateUserTeam',
        params: {
          user_no: _this.$store.state.userInfo.user_no,
          team_no: _this.team_no
        }
      }).then((res) => {
        let data = res.data
        console.log('确认加入')
        console.log(data)
        if (data.statusCode === 200) {
          _this.$message({
            message: '加入项目成功',
            center: true,
            type: 'success'
          })
          _this.$store.dispatch('setProjectList', data.data)
          _this.$router.push('/')
        } else {
          _this.$message({
            message: data.message,
            center: true,
            type: 'error'
          })
        }
      }).catch((err) => {
        console.log(err)
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
  .addTeam
    position absolute
    top 0
    bottom 0
    left 0
    right 0
    background $bgGray
    .add_dialog
      @media(min-width:768px)
        width 33rem
        height 28rem
      @media(max-width:600px)
        width 100%
        height 26rem
    .add_dialog
      background $white
      margin 10% auto
      border-radius 0.25rem
      box-shadow 0 0.375rem 0.625rem 0 $shadowGray
      text-align center
      .icon
        height 45%
        text-align center
        img
          margin-top 14%
          width 4rem
          height 4rem
      .title
        padding-left 10%
        padding-right 10%
        text-align center
        font-size 1.5rem
      .add_btn
        display inline-block
        color $white
        font-size 1.2rem
        width 16rem
        height 3.125rem
        line-height 3.125rem
        background $darkBlue
        border-radius 2.5625rem
        margin-top 5rem
      .add_btn:hover
        color $white
        background $tinGrey
        cursor pointer
</style>



// WEBPACK FOOTER //
// src/pagesPc/main/addTeam.vue